import { ReplicatedTimeout } from "../../framework/handler/ReplicatedTimeout";
export class GameReplicatedTimeoutContext {
    constructor(gameId, getWriterContext, dependencyReplicatedObjectIds, onTimeoutDeletedCallback) {
        this.seenIds = new Set();
        this.gameId = gameId;
        this.dependencyReplicatedObjectIds = dependencyReplicatedObjectIds;
        this.getWriterContext = getWriterContext;
        this.onTimeoutDeletedCallback = onTimeoutDeletedCallback;
    }
    getData() {
        return {
            gameId: this.gameId,
            dependencyReplicatedObjectIds: this.dependencyReplicatedObjectIds,
        };
    }
    registerDependency(dep) {
        if (typeof (dep) === 'string') {
            this.seenIds.add(dep);
        }
    }
    isReady() {
        return this.dependencyReplicatedObjectIds.every((id) => this.seenIds.has(id));
    }
    getKey() {
        return this.gameId;
    }
    onTimeoutDeleted() {
        this.onTimeoutDeletedCallback();
    }
}
export class GameReplicatedTimeout extends ReplicatedTimeout {
    onStart() {
        // Note: we need to initialize this here so it's available in child onStart calls.
        this.getWriterContext = this.timeoutContext.getWriterContext;
    }
    constructor(data, context, handedOff = false) {
        super(data, context, handedOff);
        this.getWriterContext = this.timeoutContext.getWriterContext;
    }
    get context() {
        return this.getWriterContext();
    }
}
export function isGameReplicatedTimeoutContextData(data) {
    return 'gameId' in data && typeof (data.gameId === 'string') && 'dependencyReplicatedObjectIds' in data;
}
export class GameReplicatedTimeoutConfig {
    constructor(className, replicatedTimeout) {
        this.__data = null;
        this.className = className;
        this.replicatedTimeout = replicatedTimeout;
    }
}
//# sourceMappingURL=GameReplicatedTimeout.js.map